import React from "react";
import PropTypes from 'prop-types';
import { Button, Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import { SlButton } from "../editors";

const NotificationModal = (props) => {
    return (
        <Modal isOpen={props.open}>
            {
                <ModalHeader>{props.title}</ModalHeader>
            }

            {
                props.message && (
                    <ModalBody className={"text-center"}>{props.message}</ModalBody>)
            }
            <ModalFooter>
                <SlButton onClick={props.ok} name={props.name ? props.name : "OK"}/>
            </ModalFooter>
        </Modal>
    );
}

NotificationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    ok: PropTypes.func.isRequired,
    message: PropTypes.string,
    name: PropTypes.string
}

export default NotificationModal;


// WEBPACK FOOTER //
// ./src/components/subcomponents/NotificationModal.jsx